import { parseCoreEpisode } from '@/adapters/core/_pure/episode';
import { resolveCoreEpisode } from '@/adapters/core/episodeCatalog';
import type { EpisodeSupport } from '@/_contract/episodeSupport';
import type { Config, CosmosDataModel, RuntimeState } from '@/adapters/core/_contract/config';
import type { CoreEpisode, CoreScene } from '@/adapters/core/_contract/episode';

export const coreEpisodeSupport = {
    parseEpisode: parseCoreEpisode,
    resolveScene: resolveCoreEpisode,
    concept: { effectKinds: ['emphasis'] },
    trace: {
        effectKinds: [],
        visualPresentation: false,
        actionStartCues: false,
        excerpts: false,
        resolve: () => { throw new Error('Core adapter has no trace episodes.'); },
    },
} satisfies EpisodeSupport<Config, RuntimeState, CosmosDataModel, CoreEpisode, CoreScene>;
